export default (state = {}, action) => {
  switch (action.type) {
    case 'GET_CATEGORIES':
      return { ...state, categories: action.categories };
    case 'GET_CATEGORIES_FEATURED':
      return { ...state, categoriesFeatured: action.categoriesFeatured };
    default:
      return state;
  }
};
